import { Box, Drawer, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { addNotebook, setNotebook, setNotebookList } from '../../../store/notebookSlice.js';
import {
	fetchNoteBookList,
	getLatestNotebookId,
	saveNotebook,
} from '../../../services/DashboardApi.js';
import { useDispatch, useSelector } from 'react-redux';

import AIPathDashboard from '../ai-path/AIPathDashboard.jsx';
import Flashcard from './flashcard/FlashCard.jsx';
import FlashcardsPage from '../flashcards/FlashcardsPage.jsx';
import Instructions from './quiz/Instructions.jsx';
import KnowledgeConceptHeader from './KnowledgeConceptHeader.jsx';
import LearningInterface from '../knowledge-concept/learning-interface/LearningInterface.jsx';
import LearningMap from './LearningMap.jsx';
import MyPathDashboard from '../my-path/MyPathDashboard.jsx';
import QuizPage from './quiz/QuizPage.jsx';
import SideBar from './SideBar.jsx';
import TextbookNotebook from './Textbook/TextbookNotebook.jsx';
import TopicLists from '../flashcards/TopicLists.jsx';
import TopicSelection from './quiz/TopicSelection.jsx';
import { fetchTopicSubtopicNames } from '../../../services/DashboardApi.js';
import { logger } from '../../../utils/logger';
import { setMainTab } from '../../../store/mainTabSlice.js';
import { setSelectedSubTopicData } from '../../../store/selectedSubTopicSlice.js';
import useIsMobile from '../../../hooks/ismobile.js';
import { useLocation } from 'react-router-dom';

//import NavBar from '../templates/NavBar.jsx'
const KnowledgeConceptPage = () => {
	//logger.log("showKnowledgeConceptPage: ",showKnowledgeConceptPage );
	const location = useLocation();
	const initialSubTab = location.state?.selectedSubTab || 'KC';
	const [selectedSubTab, setSelectedSubTab] = useState(initialSubTab); // Lifted state
	const subTabs = ['KC', 'AI Path', 'My Path', 'Quiz', 'Notebook', 'Flashcards'];
	const [currentView, setCurrentView] = useState('topicSelection');
	const [showLearningInterface, setShowLearningInterface] = useState(false);
	const [sidebarState, setSidebarState] = useState(false);
	// const [selectedNotebookId, setSelectedNotebookId] = useState(null);
	//const [selectedMainTab, setSelectedMainTab] = useState("READING_WRITING");
	const [flashCardHeaderClick, setFlashCardHeaderClick] = useState(false);
	const selectedSidebarDetails = useSelector(
		(state) => state.selectedSideBar.selectedSideBarValue
	);
	const currentNotebook = useSelector((state) => state.notebook.currentNotebook);
	const { userId } = useSelector((state) => state.userDetails);
	const selectedSubTopicDetails = useSelector(
		(state) => state.selectedSubTopic.selectedSubTopicData
	);
	const [showAIPath, setShowAIPath] = useState(false);
	const [showMyPath, setShowMyPath] = useState(false);

	/*const [selectedTopicData, setSelectedTopicData] = useState({
    topicId: null,
    subtopicId: null,
    notebookId: null,
  });*/
	const dispatch = useDispatch();

	useEffect(() => {
		if (initialSubTab === 'Flashcards') {
			setFlashCardHeaderClick(false);
		}
	}, [initialSubTab]);

	const handleGenerateQuiz = () => {
		setCurrentView('instructions');
	};

	const handleStartQuiz = () => {
		setCurrentView('quizPage');
	};

	const handleSubTopicClick = () => {
		setSelectedSubTab('Notebook');
		setShowLearningInterface(true);
	};

	const handleNoteBookSelection = async (topicId, subtopicId, notebookId) => {
		//logger.log("Notebook selected: notebookId: ", notebookId, "topicId: ", topicId, "subtopicId: ", subtopicId);

		await fetchDataForTopicSubtopicNames(topicId, subtopicId, notebookId);

		setSelectedSubTab('Notebook');
		setShowLearningInterface(true);
	};

	const fetchDataForTopicSubtopicNames = async (topicId, subtopicId, notebookId = null) => {
		let topicName = '';
		let subtopicName = '';
		let subjectName = '';
		const res = await fetchTopicSubtopicNames(topicId, subtopicId);
		logger.log('Result for topicname:', res);
		topicName = res?.data?.data?.topicName;
		subtopicName = res?.data?.data?.subtopicName;
		subjectName = res?.data?.data?.subjectName;
		logger.log(
			'TopicName: ',
			topicName,
			' SubtopicName; ',
			subtopicName,
			' Subject: ',
			subjectName
		);
		dispatch(
			setSelectedSubTopicData({
				topicId,
				subtopicId,
				notebookId,
				topicName,
				subtopicName,
				subjectName,
			})
		);
		logger.log('Subject name inside handleNoteBookSelection: ', subjectName);
		// Update the main tab selection based on subject name
		if (subjectName === 'READING_WRITING' || subjectName === 'MATHS') {
			dispatch(setMainTab(subjectName));
		}
	};

	const handleFlashcardHeaderClick = (topicId, subtopicId) => {
		setFlashCardHeaderClick(true);
	};

	//logger.log("selectedSubTab: ", selectedSubTab);
	//logger.log("currentView: ", currentView);
	//logger.log("showLearningInterface: ", showLearningInterface);
	logger.log('===============selectedSidebarDetails============= ', selectedSidebarDetails);
	const isMobile = useIsMobile();

	useEffect(() => {
		if (!showLearningInterface && currentNotebook !== null) {
			dispatch(setNotebook(null));
		}
	}, [showLearningInterface]);

	const handleCreateNotebook = (notebookName) => {
		//console.log(" Topic ID Inside handleCreateNotebook: ", selectedSubTopicDetails.topicId);
		//console.log(" Subtopic ID Inside handleCreateNotebook: ", selectedSubTopicDetails.subtopicId);
		let latestNotebookId;
		const fetchLatestNotebookId = async () => {
			try {
				let response = await getLatestNotebookId();
				let responseData = response.data.newNotebookId;
				let topicId = selectedSubTopicDetails.topicId;
				let subtopicId = selectedSubTopicDetails.subtopicId;
				latestNotebookId = responseData;
				logger.log(
					'Values inside handleCreateNotebook: TopicId: ',
					topicId,
					' ,SubtopicID: ',
					subtopicId,
					' ,latestNotebookId: ',
					latestNotebookId
				);
				const newNotebook = {
					NOTEBOOK_ID: latestNotebookId.toString(),
					NOTEBOOK_HEADER: notebookName,
					TOPIC_ID: topicId,
					SUBTOPIC_ID: subtopicId,
					USER_ID: userId,
					//USER_ID: "1049",
					UPDATED_AT: new Date().toISOString(),
				};
				logger.log('New notebook data: ', newNotebook);
				dispatch(addNotebook(newNotebook));
				saveNotebook(newNotebook);
				handleNoteBookSelection(topicId, subtopicId, latestNotebookId);
			} catch (error) {
				logger.log('Error fetching notebook list:', error);
			}
		};
		fetchLatestNotebookId();
	};
	const fetchAndSetNoteBookList = async (identifier, topicId, subtopicId, setIsLoading) => {
		// let userId = "1049";
		setIsLoading(true);
		try {
			const response = await fetchNoteBookList(userId, identifier, topicId, subtopicId);
			let responseData = response.data?.noteBookList;
			logger.log('Notebook list data: ', responseData);
			if (responseData.length != 0) {
				responseData = responseData.sort(
					(a, b) => new Date(b.UPDATED_AT) - new Date(a.UPDATED_AT)
				);
				logger.log('Printing Sorted Notebook List: ', responseData);
			}
			dispatch(setNotebookList(responseData));
		} catch (error) {
			logger.log('Error fetching notebook list:', error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleSubTopicClickInternal = async (topicId, subtopicId, setIsLoading) => {
		await fetchDataForTopicSubtopicNames(topicId, subtopicId);
		let identifier =
			topicId === '' && subtopicId === '' ? 'USER_SPECIFIC' : 'TOPIC_SUBTOPIC_SPECIFIC';

		await fetchAndSetNoteBookList(identifier, topicId, subtopicId, setIsLoading);

		handleSubTopicClick(); // Existing handler
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				width: '100%',
				height: '100%',
				maxHeight: '100vh',
			}}
		>
			{!isMobile && (
				<div
					className={'kc_header_top'}
					style={{ position: 'sticky', top: '64px', zIndex: 1000 }}
				>
					<KnowledgeConceptHeader
						selectedSubTab={selectedSubTab}
						setSelectedSubTab={setSelectedSubTab}
						subTabs={subTabs}
						setShowLearningInterface={setShowLearningInterface}
						setFlashCardHeaderClick={setFlashCardHeaderClick}
						setShowAIPath={setShowAIPath}
						setShowMyPath={setShowMyPath}
					/>
				</div>
			)}
			<Box sx={{ display: 'flex', flexDirection: 'row' }}>
				{/* {selectedSidebarDetails =='Notebook' && <SideBar handleNoteBookSelection={handleNoteBookSelection} />}
            {selectedSidebarDetails == "Topics" && <TopicLists/>} */}
				{!isMobile && !['AI Path', 'My Path', 'Quiz'].includes(selectedSubTab) && (
					<div
						style={{
							minWidth: '250px',
							flexShrink: 0,
							background: '#242424',
							color: 'white',
						}}
					>
						{selectedSidebarDetails === 'Notebook' && (
							<SideBar
								handleNoteBookSelection={handleNoteBookSelection}
								setSidebarState={setSidebarState}
								showLearningInterface={showLearningInterface}
								selectedSubTab={selectedSubTab}
								handleCreateNotebook={handleCreateNotebook}
								// setSelectedNotebookId={setSelectedNotebookId}
								// selectedNotebookId={selectedNotebookId}
							/>
						)}
						{selectedSidebarDetails === 'Topics' && <TopicLists />}
					</div>
				)}
				{isMobile && !['AI Path', 'My Path', 'Quiz'].includes(selectedSubTab) && (
					<Drawer
						open={sidebarState}
						onClose={() => setSidebarState(false)}
						sx={{
							minWidth: '100vw',
							flexShrink: 0,
							background: '#242424',
							color: 'white',
							width: '100vw',
							zIndex: 1500,
							position: 'sticky',
							top: '64px',
							bottom: 0,
						}}
					>
						{selectedSidebarDetails === 'Notebook' && (
							<SideBar
								handleNoteBookSelection={handleNoteBookSelection}
								setSidebarState={setSidebarState}
								showLearningInterface={showLearningInterface}
								selectedSubTab={selectedSubTab}
								handleCreateNotebook={handleCreateNotebook}
								// setSelectedNotebookId={setSelectedNotebookId}
								// selectedNotebookId={selectedNotebookId}
							/>
						)}
						{selectedSidebarDetails === 'Topics' && <TopicLists />}
					</Drawer>
				)}
				<div
					style={{
						// flexGrow: 1,
						minWidth: '0',
						overflowX: 'hidden',
						maxWidth:
							!isMobile && !['AI Path', 'My Path', 'Quiz'].includes(selectedSubTab)
								? 'calc(100vw - 250px)'
								: '100vw',
						width:
							!isMobile && !['AI Path', 'My Path', 'Quiz'].includes(selectedSubTab)
								? 'calc(100vw - 250px)'
								: '100vw',
					}}
				>
					{selectedSubTab === 'KC' && !showLearningInterface && (
						<LearningMap
							// handleSubTopicClick={handleSubTopicClick}
							handleSubTopicClickInternal={handleSubTopicClickInternal}
							fetchAndSetNoteBookList={fetchAndSetNoteBookList}
							setSidebarState={setSidebarState}
						/>
					)}
					{/* {selectedSubTab === "KC" && showLearningInterface && <LearningInterface/>} */}
					{selectedSubTab === 'Quiz' && currentView === 'topicSelection' && (
						<div style={{ maxWidth: '100%', overflowX: 'hidden' }}>
							<TopicSelection
								handleGenerateQuiz={handleGenerateQuiz}
								setSidebarState={setSidebarState}
							/>
						</div>
					)}
					{selectedSubTab === 'Quiz' && currentView === 'instructions' && (
						<Instructions handleStartQuiz={handleStartQuiz} />
					)}
					{selectedSubTab === 'Quiz' && currentView === 'quizPage' && <QuizPage />}

					{selectedSubTab === 'Notebook' && showLearningInterface && (
						<Box
							sx={{
								height:
									// currentNotebook === 'default'
									// 	? 'auto'
									// 	: {
									// 			xs: 'calc(100vh - 173.8px)',
									// 			sm: 'calc(100vh - 192.8px)',
									// 	  },
									{
										xs: 'calc(100vh - 173.8px)',
										sm: 'calc(100vh - 192.8px)',
									},
								// overflowY: 'hidden',
								overflowY: currentNotebook === 'default' ? 'auto' : 'hidden',
								scrollbarWidth: 'none',
								'-ms-overflow-style': 'none',
								'&::-webkit-scrollbar': {
									display: 'none', // Chrome, Safari, Opera
								},
							}}
						>
							{currentNotebook === 'default' ? (
								<TextbookNotebook
									handleSubTopicClickInternal={handleSubTopicClickInternal}
								/>
							) : (
								<LearningInterface
									// setSelectedNotebookId={setSelectedNotebookId}
									// selectedNotebookId={selectedNotebookId}
									handleNoteBookSelection={handleNoteBookSelection}
									handleCreateNotebook={handleCreateNotebook}
									setSidebarState={setSidebarState}
								/>
							)}
						</Box>
					)}
					{selectedSubTab === 'Flashcards' &&
						!showLearningInterface &&
						!flashCardHeaderClick && (
							<FlashcardsPage
								handleFlashcardHeaderClick={handleFlashcardHeaderClick}
							/>
						)}
					{selectedSubTab === 'Flashcards' &&
						!showLearningInterface &&
						flashCardHeaderClick && <Flashcard />}
					{selectedSubTab === 'AI Path' && showAIPath && <AIPathDashboard />}
					{selectedSubTab === 'My Path' && showMyPath && <MyPathDashboard />}
				</div>
			</Box>
			{isMobile && (
				<div
					className={'kc_header_bottom'}
					style={{ position: 'sticky', bottom: '0', zIndex: 1000 }}
				>
					<KnowledgeConceptHeader
						selectedSubTab={selectedSubTab}
						setSelectedSubTab={setSelectedSubTab}
						subTabs={subTabs}
						setShowLearningInterface={setShowLearningInterface}
						setFlashCardHeaderClick={setFlashCardHeaderClick}
						setShowAIPath={setShowAIPath}
						setShowMyPath={setShowMyPath}
					/>
				</div>
			)}
		</div>
	);
};

export default KnowledgeConceptPage;
